// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pf-0";
export var animationContainer = "_pf-1";
export var itemPrice = "_pf-a";
export var itemizedContent = "_pf-9";
export var itemizedHeader = "_pf-7";
export var itemizedRow = "_pf-8";
export var itemizedSection = "_pf-6";
export var modalContent = "_pf-2";
export var orderName = "_pf-3";
export var refundOption = "_pf-4";
export var refundOptionsContainer = "_pf-5";
export var shippingLabel = "_pf-b";
export var totalRow = "_pf-c";